const t="2.32.0-beta.1";export{t as version};
